module.exports = __webpack_public_path__ + "media/a2.857b4ba6.mp3";